module.exports = __webpack_public_path__ + "img/branding-logo.d48c1c4d.svg";